import React from "react";
import "./style.css";
export default function CategoryTitle(props) {
    return (React.createElement("h2", { className: "category-title" }, props.title));
}
